import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Button, Icon } from 'shpmtcd'

import AccountDropdown from './AccountDropdown'

class MyAccount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showDropdown: false,
    }
  }

  componentDidMount() {
    const dropdownElement = document.getElementById('my-account')
    window.addEventListener('click', (e) => {
      const clickedDropdown = dropdownElement.contains(e.target)
      if (!clickedDropdown) {
        this.handleClickAwayEvent()
      }
    })
  }

  handleClickAwayEvent = () => {
    this.setState({
      showDropdown: false,
    })
  }

  handleClickEvent = () => {
    this.setState((state) => ({
      showDropdown: !state.showDropdown,
    }))
  }

  handleRouteChange = (id) => {
    const path = `/${id}`
    const { history, handleChangePassword, onClickLogout } = this.props

    if (id !== 'changePassword') {
      if (id === 'logout') {
        onClickLogout()
      } else history.push(path)
    }
    if (id === 'changePassword') {
      handleChangePassword()
    }
  }

  render() {
    const { showDropdown } = this.state
    const { customerData, onClickLogout, color } = this.props
    const { firstName, isLoggedin } = customerData
    const firstLetter = firstName ? firstName.charAt(0).toUpperCase() : ''
    return (
      <div id='my-account' className='my-account'>
        <div className={isLoggedin ? 'login' : 'logout'}>
          <Button
            className='login-btn'
            type='Text'
            onClick={this.handleClickEvent}
          >
            <div>
              {
              isLoggedin
                ? <div className='user-circle'> {firstLetter} </div>
                : <Icon type='shpmtcdicon-zen-user-bold' />
              }
              {
                isLoggedin
                  ? <div className='user-name-background' style={{ backgroundColor: color }} />
                  : null
              }
            </div>
          </Button>
        </div>
        {showDropdown
          && (
            <AccountDropdown
              isSignedIn={isLoggedin}
              customerName={firstName}
              onClickLogout={onClickLogout}
              onMenuClick={(id) => this.handleRouteChange(id)}
            />
          )}
      </div>
    )
  }
}

MyAccount.propTypes = {
  customerData: PropTypes.shape({
    firstName: PropTypes.string,
    isLoggedin: PropTypes.bool,
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  handleChangePassword: PropTypes.func.isRequired,
  onClickLogout: PropTypes.func.isRequired,
  color: PropTypes.string,
}

MyAccount.defaultProps = {
  customerData: {
    firstName: undefined,
    isLoggedin: false,
  },
  color: '',
}

export default MyAccount
